import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const PatientInfo = ({ patientDetails, caseDetails }) => {
  return (
    <div className="sticky top-2   bg-white z-[1200]">
      <Accordion
        className=" w-full border-2 border-solid border-[#E1E1E1] rounded-[30px]"
        sx={{ borderRadius: "30px" }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          sx={{ background: "white" }}
        >
          <div className=" w-full flex justify-between items-center">
            <div>
              <div className="font-medium">Patient Name</div>
              <div className="text-sm mt-1">{patientDetails?.patientName}</div>
            </div>
            <div>
              <div className="font-medium">Age</div>
              <div className="text-sm mt-1">{patientDetails?.age}</div>
            </div>
            <div>
              <div className="font-medium">Gender</div>
              <div className="text-sm mt-1">{patientDetails?.gender}</div>
            </div>
            <div>
              <div className="font-medium">Registration Id</div>
              <div className="text-sm mt-1">
                {caseDetails?.pmjayRegistrationId}
              </div>
            </div>
            <div>
              <div className="font-medium">Beneficiary No.</div>
              <div className="text-sm mt-1">
                {patientDetails?.beneficiaryNo}
              </div>
            </div>
            <div>
              <div className="font-medium">Registered Date</div>
              <div className="text-sm mt-1">
                {patientDetails?.registeredDate
                  ? new Date(patientDetails?.registeredDate)?.toLocaleString(
                      "en-GB",
                      {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                        hour12: true,
                      },
                    )
                  : "----"}
              </div>
            </div>
            <div>
              <div className="font-medium">Care Plan</div>
              <div>{caseDetails?.carePlan || "--"}</div>
            </div>

            <div>
              <div className="font-medium">Admission Date</div>

              <div className="text-sm mt-1">
                {caseDetails?.admissionDate
                  ? new Date(caseDetails?.admissionDate)?.toLocaleString(
                      "en-GB",
                      {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                        //   hour: "2-digit",
                        //   minute: "2-digit",
                        //   second: "2-digit",
                        //   hour12: true,
                      },
                    )
                  : "----"}
              </div>
            </div>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          {" "}
          <div className="flex gap-2 justify-between">
            <div>
              <div className="font-medium">Admission Type / Case Type</div>
              <div className="text-sm mt-1">
                {caseDetails?.admissionType} /{" "}
                {caseDetails?.caseType === "DAYCARE" &&
                caseDetails?.caseSubType?.toUpperCase() === "DIALYSIS"
                  ? `${caseDetails.caseType} (${
                      caseDetails.caseSubType?.charAt(0).toUpperCase() +
                      caseDetails.caseSubType?.slice(1).toLowerCase()
                    })`
                  : caseDetails?.caseType}
              </div>
            </div>
            {/* <div>
              <div className="font-medium">Case Type</div>
              <div className="text-sm mt-1">{caseDetails?.caseType}</div>
            </div> */}
            <div>
              <div className="font-medium">Primary Diagnosis</div>
              <div className="text-sm mt-1">
                {caseDetails?.primaryDiagnosisDetails?.value || "-----"}
              </div>
            </div>
            <div>
              <div className="font-medium">Secondary Diagnosis</div>
              <div className="text-sm mt-1">
                {caseDetails?.secondaryDiagnosisDetails?.value || "----"}
              </div>
            </div>
            <div>
              <div className="font-medium">Total Package Cost</div>
              <div className="text-sm mt-1">
                {caseDetails?.totalPackageCost}
              </div>
            </div>
            <div>
              <div className="font-medium">Address</div>
              <div>
                {patientDetails?.city},{patientDetails?.state}
              </div>
            </div>
            <div>
              <div className="font-medium">LOS</div>
              <div className="text-sm mt-1">---</div>
            </div>
          </div>
          <div className="bg-[#F5F5F5]">
            <div className="flex gap-2">
              <div className="w-[30px]"></div>
              <div className="flex-1 grid grid-cols-13 mt-5">
                <div className="font-medium text-center   col-span-2 ">
                  Spec Name
                </div>
                <div className="font-medium text-center ">P ID</div>
                <div className="font-medium text-center  col-span-4">
                  Procedure Name
                </div>
                <div className="font-medium text-center ">ICHI Code</div>
                <div className="font-medium text-center  col-span-2">
                  Stratifications
                </div>
                <div className="font-medium text-center  col-span-2">
                  Implants
                </div>
                <div className="font-medium text-center ">Dr Name</div>
              </div>
            </div>
            <div>
              {(caseDetails?.caseProcedures
                ? caseDetails?.caseProcedures
                : caseDetails?.caseprocedures
              )?.map((procedure, idx) => {
                return (
                  <div key={idx} className="flex gap-2">
                    <div>
                      <div className="w-[30px] text-sm font-semibold pl-1">
                        P{idx + 1}
                      </div>
                    </div>
                    <div className="flex-1 grid grid-cols-13">
                      <div className="text-sm border border-solid border-[#e2e2e2] px-1 py-1 col-span-2 ">
                        {procedure?.speciality || "---"}
                      </div>
                      <div className="text-sm border border-solid border-[#e2e2e2] px-1 py-1 ">
                        {procedure?.procedureId || "---"}
                      </div>
                      <div className="text-sm border border-solid border-[#e2e2e2] px-1 py-1 col-span-4">
                        {procedure?.procedure?.slice(7) || "---"}
                      </div>
                      <div className="text-sm border border-solid border-[#e2e2e2] px-1 py-1">
                        {procedure?.ichiCode || "---"}
                      </div>
                      <div className="text-sm border border-solid border-[#e2e2e2] px-1 py-1 col-span-2">
                        {procedure?.stratification || "---"}
                      </div>
                      <div className="text-sm border border-solid border-[#e2e2e2] px-1 py-1 col-span-2">
                        {procedure?.implants || "---"}
                      </div>
                      <div className="text-sm border border-solid border-[#e2e2e2] px-1 py-1">
                        {procedure?.doctorName || "---"}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default PatientInfo;
